import React from 'react';
// import * as properties from '../../elementsPropertiesItems';
// import Icons from '../../../Icons/Icons';
import { isSet } from '../../../../Utils/CommonFunctions';


const FontSize =(props)=>{
	const {path,keyParam,elementData} = props;
	let fontSizeValue = isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:'14px';
	let fontNum = fontSizeValue.match(/\d/g);
	fontNum = fontNum.join("");


	const changeHandler = (e) => {
		const {value} = e.target;
		let valuePx = value+'px';
		props.changeHandler(path,keyParam,valuePx)
	}

	const fontSizeHandler = (operator) => {		
		if(operator==='plus'&& fontNum<30){
			fontNum = parseInt(fontNum) + 1;	
		}else if(operator==='minus' && fontNum>1){
			fontNum = parseInt(fontNum) - 1
		}
		
		let valuePx = fontNum+'px';
		props.changeHandler(path,keyParam,valuePx)
	}

	//onChange={()=>props.changeHandler(path,keyParam,item.value)}
    return(
        <div className="input-group">
			<div className="input-group-prepend">
				<span className="input-group-text cursor-pointer" onClick={()=>fontSizeHandler('minus')}> 
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" x="0" y="0" version="1.1" viewBox="0 0 29 29" ><path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" d="M22 14.5H7"></path></svg>
				</span>
				<span className="input-group-text cursor-pointer" onClick={()=>fontSizeHandler('plus')}>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256" id="plus"><rect width="256" height="256" fill="none"></rect><line x1="40" x2="216" y1="128" y2="128" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="12"></line><line x1="128" x2="128" y1="40" y2="216" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="12"></line></svg>
				</span>
			</div>
			<input type="number" className="form-control" aria-label="Amount (to the nearest dollar)" value={fontNum} onChange={e=>changeHandler(e)} />
			<div className="input-group-append">
				<span className="input-group-text"> px </span>
				
			</div>
		</div>
    )
}

FontSize.defaultProps = {
    fontWeightValue: '14px',    
};

export default FontSize;
